import React, { useEffect, useRef, useState } from 'react'; 
import { POS } from '../../../../constant/pos'; 
import { Box, Grid, Card, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'; 
import axios from 'axios';
import CustomForm from '../../../../components/form/form';
import { CustomBtn } from '../../../../components/button/button';
import PageContainer from '../../../../components/Container/pageContainer'; 
import SuppliersList from './suppliersList';
import { ShowLoader } from '../../../../redux/actions/loader';

const Auth = (props) => {
    const [data, setData] = useState(POS().Supplier);
    const dispatch = useDispatch();
    const api = useSelector((state) => state.Api);
    const getfilterdata = data.inputs.filter((item) => item.feildtype !== 'label');
    const [tabValue, setTabValue] = useState(1);

    const initialInputValues = Object.fromEntries(getfilterdata.map(item => [item.name, '']));
    const [inputValues, setInputValues] = useState(initialInputValues);
    const [butnVisiablity, setButnVisiablity] = useState(true);
    const [formKey, setFormKey] = useState(0);
    const [suggestions, setSuggestions] = useState([]);
    const [products, setProducts] = useState([]);
    const [refreshTrigger, setRefreshTrigger] = useState(false);
    const [duplicateWarning, setDuplicateWarning] = useState('');
    const [isDuplicate, setIsDuplicate] = useState(false);
    let initialMount = useRef(false)
    // Fetch supplier suggestions
    const fetchSuppliers = async () => {
        const cachedSuppliers = sessionStorage.getItem('Suppliers');
        if (cachedSuppliers) {
            setSuggestions(JSON.parse(cachedSuppliers));
            return; // Exit early if data exists in sessionStorage
        }
        if (initialMount.current) return;
        initialMount.current = true
        const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;
        try {
            const response = await axios.get(api.showSupplier, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            });
            if (response.status === 200) {
                const sortedData = response.data.data.sort((a, b) => b.supplier_id - a.supplier_id);
                //console.log(sortedData)
                setSuggestions(sortedData);
                sessionStorage.setItem('Suppliers',JSON.stringify(sortedData))
            }
        } catch (err) {
            console.error('Error fetching suppliers:', err);
        }
    };

    useEffect(() => {
        fetchSuppliers();
    }, [api.showsupplier, refreshTrigger]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // //console.log(e.target.value)
        setInputValues(prevValues => ({
            ...prevValues,
            [name]: value,
        }));

        // Check for duplicate phone number when phone number field changes
        if (name === 'phoneNumber' && value) {
            checkDuplicatePhone(value);
        } else if (name !== 'phoneNumber') {
            // Reset duplicate warning if editing other fields
            setDuplicateWarning('');
            setIsDuplicate(false);
        }
    };

    const checkDuplicatePhone = (phoneNumber) => {
      //console.log(phoneNumber)
        const duplicateSupplier = suggestions.find(supplier => 
            supplier.phone_number === phoneNumber
        );
        //console.log('phone_number')
        if (duplicateSupplier) {
            setDuplicateWarning(`عرضه کوونکی لا دمخه د دې تلیفون شمیره سره راجستر شوی دی`);
            setIsDuplicate(true);
        } else {
            setDuplicateWarning('');
            setIsDuplicate(false);
        }
    };

    const myfunc = async (event) => {
        event.preventDefault();
        if (isDuplicate) return;
        dispatch(ShowLoader('1'))
        setButnVisiablity(false);
        const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;
        
        try {
            const response = await axios.post(api.addSupplier, JSON.stringify(inputValues), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            });
            if (response.status === 200) {
                const sortedData = response.data.suppliers.sort((a, b) => b.supplier_id - a.supplier_id);
                //console.log(sortedData)
                setSuggestions(sortedData);
                sessionStorage.setItem('Suppliers',JSON.stringify(sortedData))
                dispatch(ShowLoader('0'))
                dispatch({
                    type: 'SHOW_MODAL',
                    response: response.data,
                    severity: 'Success'
                });
                initialMount.current = false
                setRefreshTrigger(prev => !prev);
            }
        } catch (err) {
            console.error('Error adding supplier:', err);
            dispatch({
                type: 'SHOW_MODAL',
                response: err.response?.data || { message: 'Error adding supplier' },
                severity: 'Error'
            });
        } finally {
            refreshForm();
            setInputValues(initialInputValues);
            setButnVisiablity(true);
        }
    };

    const refreshForm = () => {
        setFormKey(prevKey => prevKey + 1);
    };

    return (
        <PageContainer title={data.title} description={data.description}>
            <Box>
                <Grid container spacing={0} justifyContent="center" sx={{ minHeight: '100vh', padding: '0px 0px' }}>
                    <Grid item xs={12} sm={12} lg={12} xl={12} display="flex" justifyContent="center" alignItems="center">
                        <Card elevation={9} sx={{ p: 2, zIndex: 1, width: '100%', maxWidth: '100%' }}>
                            <Box sx={{ mt: 2 }}>
                                <Grid container>
                                    <SuppliersList rows={suggestions} />
                                </Grid>
                                 
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </PageContainer>
    );
};

Auth.propTypes = {};

export default Auth;